import LAYOUT_CONST, { DEFAULT_LOGO_URL } from 'constant';
import { KeyedObject, ColorProps } from 'types';
// Predefined Theme Color
import theme0 from './assets/scss/_themes-vars.module.scss';
import theme1 from './assets/scss/_theme1.module.scss';
import theme2 from './assets/scss/_theme2.module.scss';
import theme3 from './assets/scss/_theme3.module.scss';
import theme4 from './assets/scss/_theme4.module.scss';
import theme5 from './assets/scss/_theme5.module.scss';
import theme6 from './assets/scss/_theme6.module.scss';
// types
import { ConfigProps } from 'types/config';
export const PredefinedThemes: { [key: string]: ColorProps } = {
    theme0,
    theme1,
    theme2,
    theme3,
    theme4,
    theme5,
    theme6
};

export const JWT_API = {
    secret: 'SECRET-KEY',
    timeout: '1 days'
};

export const FIREBASE_API = {
    apiKey: 'AIzaSyBernKzdSojh_vWXBHt0aRhf5SC9VLChbM',
    authDomain: 'berry-material-react.firebaseapp.com',
    projectId: 'berry-material-react',
    storageBucket: 'berry-material-react.appspot.com',
    messagingSenderId: '901111229354',
    appId: '1:901111229354:web:a5ae5aa95486297d69d9d3',
    measurementId: 'G-MGJHSL8XW3'
};

export const AUTH0_API = {
    client_id: '7T4IlWis4DKHSbG8JAye4Ipk0rvXkH9V',
    domain: 'dev-w0-vxep3.us.auth0.com'
};

export const AWS_API = {
    poolId: 'us-east-1_AOfOTXLvD',
    appClientId: '3eau2osduslvb7vks3vsh9t7b0'
};

// basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
// like '/berry-material-react/react/default'
export const BASE_PATH = '';

export const DASHBOARD_PATH = '/home';
export const ONBOARDING_PATH = '/home';
export const FUNDS_PATH = '/payouts/transactions';

export const HORIZONTAL_MAX_ITEM = 6;

// CRM Config Keys
export const SECTIONS = 'enabled_sections';
export const LOGO_URL = 'logo_light';
export const LOGO_DARK_URL = 'logo_dark';
export const FAVICON_URL = 'logo_favicon';
export const MENU_TYPE = 'menu_type';
export const DRAWER_TYPE = 'drawerType';
export const COLOR_MODE = 'color_mode';
export const NAV_TYPE = 'navType';
export const THEME = 'theme';
export const ACTIONS = 'bar_actions';
export const KeysToAttributes: KeyedObject = {
    [LOGO_URL]: 'logoLight',
    [LOGO_DARK_URL]: 'logoDark',
    [MENU_TYPE]: 'layout',
    [COLOR_MODE]: 'navTypeOptions'
};
export const LOGO_KEYS: string[] = [LOGO_URL, LOGO_DARK_URL];
export const NavLight = 'light';
export const NavDark = 'dark';
export const NavOptions = [NavLight, NavDark];
const config: ConfigProps = {
    ready: false,

    itemsPerPage: 10,
    layout: LAYOUT_CONST.VERTICAL_LAYOUT, // vertical, horizontal
    drawerType: LAYOUT_CONST.DEFAULT_DRAWER, // default, mini-drawer
    fontFamily: `'Onest', sans-serif`,
    borderRadius: 8,
    outlinedFilled: true,
    navTypeOptions: NavOptions,
    navType: NavLight, // light, dark
    presetColor: 'default', // default, theme1, theme2, theme3, theme4, theme5, theme6
    locale: 'en', // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
    rtlLayout: false,
    container: false,
    logoLight: { url: DEFAULT_LOGO_URL, file_id: '' },
    logoDark: { url: DEFAULT_LOGO_URL, file_id: '' },
    theme: theme0,
    enabled_sections: [],
    bar_actions: [],
    is_profile_editable: false,
    profile_editable_attributes: [],
    footer_message: '',
    custom_js_code: '',
    resources_head: ''
};

export default config;
